





import Vue from "vue";
import { Component } from "vue-property-decorator";
import "@/assets/themes/defaultstyle.scss";
import { EventBus } from "@/EventBus.ts";

@Component({
  name: "default-style",
})
export default class DefaultStyle extends Vue {
  public mounted() {
    EventBus.$emit("theme:loaded");
  }
}
